module.exports = __webpack_public_path__ + "static/media/a38.291a53a5.jpg";